import style from "./ProductCardSkeleton.module.css"

export default function ProductCardSkeleton() {
  return (
    <div className={style.card} aria-hidden="true">
      <div className={style.image} />
      <div className={style.swatches}>
        <span className={style.swatch} />
        <span className={style.swatch} />
        <span className={style.swatch} />
        <span className={style.swatch} />
        <span className={style.swatch} />
      </div>
      <div className={`${style.line} ${style.title}`} />
      <div className={`${style.line} ${style.price}`} />
    </div>
  )
}
